module.exports = __webpack_public_path__ + "static/media/add-receipt.1b51e25b.svg";